import { Link } from "react-router-dom";


function NotFound() {
    return
    <div>
        <h1> Ops</h1>
        <p>A pagina que tentou acessar não existe</p>
        <Link to="/">Voltar para pagina inicial </Link>

    </div>

}
export default NotFound;